import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CouponRedeemRequestBody, CouponRedeemResponse } from "./types";

export class CouponRedeemAPI extends BaseAPI<
  CouponRedeemRequestBody,
  CouponRedeemResponse
> {
  protected route = ApiRoutes.coupon.redeem;
  protected method = RequestMethod.POST;
}
